<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje dogodka</span>
                    <span v-if="!editMode">Dodajanje dogodka</span>
                </h1>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <!--                current step: {{event.currentFormStep}}<br/>-->
                <!--                {{errors}}-->

                <div>
                    <b-tabs content-class="mt-3 ">
                        <b-tab title="1. Načrtovanje" active class="w-100 clearfix">

                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">

                                        <b-form-group
                                                label="Določi v kater projekt dogodek sodi"
                                                label-for="project"
                                                :class="{'is-invalid': errors.has('project')}">

                                            <v-select
                                                    v-model="event.project"
                                                    placeholder="projekt"
                                                    id="project"
                                                    name="project"
                                                    :options="projects"
                                                    label="name"
                                                    :reduce="item => item.id"
                                                    v-validate="'required'"
                                                    multiple
                                            >
                                                <span slot="no-options">Ni zadetkov.</span>
                                                <template slot="option" slot-scope="item">
                                                    {{item.name}}
                                                </template>
                                                <template slot="selected-option" slot-scope="item">
                                                    {{item.name}}
                                                </template>

                                            </v-select>
                                            <div class="invalid-feedback" v-if="errors.has('project')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                label="Določi status termina dogodka"
                                                label-for="dateConfirmed"
                                                :class="{'is-invalid': errors.has('dateConfirmed')}">

                                            <v-select
                                                    v-model="event.dateConfirmed"
                                                    placeholder="status termina"
                                                    id="dateConfirmed"
                                                    name="dateConfirmed"
                                                    :options="['termin je potrjen', 'planiran termin']"
                                                    @input="checkDateConfirmedValue"
                                                    v-validate="'required'"
                                            >
                                                <span slot="no-options">Ni zadetkov.</span>
                                            </v-select>
                                            <div class="invalid-feedback" v-if="errors.has('dateConfirmed')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                label="Določi datum in čas dogodka"
                                                label-for="date"
                                                :class="{'is-invalid': errors.has('date')}">

                                            <VueCtkDateTimePicker id="date" name="date" key="date"
                                                                  format="YYYY-MM-DDTHH:mm:ssZ"
                                                                  class="withLabel" locale="sl"
                                                                  formatted="dddd, Do MMMM YYYY, HH:mm"
                                                                  label="Datum in čas dogodka"
                                                                  v-model="event.date"
                                                                  v-validate="'required'"
                                            />

                                            <div class="invalid-feedback" v-if="errors.has('date')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>


                                        <b-form-group label="Ali dogodek traja več dni?">
                                            <div>
                                                <b-form-checkbox
                                                        v-model="event.multipleDayEvent"
                                                        size="lg"
                                                        switch> Večdnevni dogodek
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                v-if="event.multipleDayEvent"
                                                label="Določi datum in čas zaključka dogodka"
                                                label-for="endDate"
                                                :class="{'is-invalid': errors.has('endDate')}">

                                            <VueCtkDateTimePicker id="endDate" name="endDate" key="endDate"
                                                                  format="YYYY-MM-DDTHH:mm:ssZ"
                                                                  class="withLabel" locale="sl"
                                                                  formatted="dddd, Do MMMM YYYY, HH:mm"
                                                                  label="Datum in čas zaključka dogodka"
                                                                  v-model="event.endDate"
                                                                  v-validate="validationRuleMultipleDayEvent"
                                            />

                                            <div class="invalid-feedback" v-if="errors.has('endDate')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="addressName"
                                                label="Vnesi naziv lokacije (npr. Delezova domačija)"
                                                label-for="addressName"
                                                :class="{'is-invalid': errors.has('addressName')}">
                                            <b-form-input
                                                    id="addressName"
                                                    name="addressName"
                                                    v-model="event.addressName"
                                                    placeholder="naziv lokacije"
                                                    v-validate="'required'"
                                                    trim></b-form-input>
                                            <div class="invalid-feedback" v-if="errors.has('addressName')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="address"
                                                label="Vnesi naslov"
                                                label-for="address"
                                                :class="{'is-invalid': errors.has('address')}">


                                            <GmapAutocomplete
                                                    id="address"
                                                    ref="autocomplete"
                                                    @place_changed="onPlaceChanged"
                                                    :value="event.address"
                                                    placeholder="vnesi naslov" class="form-control"
                                                    @input="value = $event.target.value"></GmapAutocomplete>

                                            <b-form-input
                                                    style="display: none"
                                                    name="address"
                                                    v-model="event.address"
                                                    v-validate="'required'"
                                                    trim></b-form-input>

                                            <div class="invalid-feedback" v-if="errors.has('address')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="municipality"
                                                label="Vnesi naziv občine, kjer se bo dogodek odvijal"
                                                label-for="municipality"
                                                :class="{'is-invalid': errors.has('municipality')}">
                                            <b-form-input id="municipality" name="municipality"
                                                          v-model="event.municipality" placeholder="naziv občine"
                                                          v-validate="'required'" trim></b-form-input>
                                            <div class="invalid-feedback" v-if="errors.has('municipality')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                label="Opiši planirane aktivnosti na dogodku"
                                                label-for="activities"
                                                :class="{'is-invalid': errors.has('activities')}">
                                                <textarea v-model="event.activities" id="activities" name="activities"
                                                          placeholder="aktivnosti" class="form-control"
                                                          style="height: auto"
                                                          required rows="5" v-validate="'required'"> </textarea>
                                            <div class="invalid-feedback" v-if="errors.has('activities')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                    </div>
                                </div>
                            </div>

                        </b-tab>
                        <b-tab title="2. Napovednik" :disabled="event.currentFormStep < 2">

                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">

                                        <b-form-group
                                                id="eventName"
                                                label="Vnesi naziv dogodka"
                                                label-for="eventName"
                                                :class="{'is-invalid': errors.has('eventName')}">
                                            <b-form-input id="eventName" name="eventName" v-model="event.eventName"
                                                          placeholder="naziv dogodka" v-validate="'required'"
                                                          trim></b-form-input>
                                            <div class="invalid-feedback" v-if="errors.has('eventName')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="coHosts"
                                                label="Naštej morebitne soorganizatorje dogodka (če jih ni, pusti prazno)"
                                                label-for="coHosts"
                                                :class="{'is-invalid': errors.has('coHosts')}">
                                            <b-form-input id="coHosts" name="coHosts" v-model="event.coHosts"
                                                          placeholder="soorganizatorji dogodka" trim></b-form-input>
                                            <div class="invalid-feedback" v-if="errors.has('coHosts')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="description"
                                                label="Napiši kratek opis oz. napoved (za spletno stran)"
                                                label-for="description"
                                                :class="{'is-invalid': errors.has('description')}">
                                                <textarea v-model="event.description" id="description"
                                                          name="description"
                                                          placeholder="opis dogodka" class="form-control"
                                                          style="height: auto" v-validate="'required'"
                                                          required rows="5"> </textarea>

                                            <div class="invalid-feedback" v-if="errors.has('description')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group label="Ali se morajo udeleženci predhodno prijaviti?">
                                            <div>
                                                <b-form-checkbox
                                                        v-model="event.registrationRequired"
                                                        size="lg"
                                                        switch> Prijava
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="registrationLink"
                                                label="Vnesi email oz. povezavo za prijavo"
                                                label-for="registrationLink"
                                                v-if="event.registrationRequired"
                                                :class="{'is-invalid': errors.has('registrationLink')}">
                                            <b-form-input id="registrationLink" name="registrationLink"
                                                          v-model="event.registrationLink"
                                                          placeholder="email oz. povezava za registracijo"
                                                          v-validate="validationRuleRegistrationRequired"
                                                          trim></b-form-input>

                                            <div class="invalid-feedback" v-if="errors.has('registrationLink')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group label="Ali je število mest za udeležence omejeno?"
                                                      for="maxParticipantsLimit">
                                            <div>
                                                <b-form-checkbox
                                                        id="maxParticipantsLimit"
                                                        v-model="event.maxParticipantsLimit"
                                                        size="lg"
                                                        switch> Omejitev števila udeležencev
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="maxParticipants"
                                                label="Vnesi maksimalno število udeležencev"
                                                label-for="registrationLink"
                                                v-if="event.maxParticipantsLimit"
                                                :class="{'is-invalid': errors.has('maxParticipants')}">
                                            <b-input-group append="udeležencev">
                                                <b-form-input id="maxParticipants" name="maxParticipants"
                                                              v-model="event.maxParticipants"
                                                              placeholder="maksimalno število udeležencev" type="number"
                                                              v-validate="validationRuleMaxParticipants"
                                                              trim></b-form-input>
                                            </b-input-group>
                                            <div class="invalid-feedback" v-if="errors.has('maxParticipants')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>


                                        <b-form-group label="Ali naj se dogodek oglašuje na FaceBook-u?">
                                            <div>
                                                <b-form-checkbox
                                                        v-model="event.advertising"
                                                        size="lg"
                                                        switch> FB oglaševanje
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="notes"
                                                label="Napiši opombe"
                                                label-for="notes"
                                                :class="{'is-invalid': errors.has('notes')}">
                                                <textarea v-model="event.notes" id="notes" name="notes"
                                                          placeholder="opombe (npr. kaj morajo udeleženci prinesti s sabo, kako je z dogodkom v primeru slabega vremenna ipd.)"
                                                          class="form-control" style="height: auto"
                                                          required rows="5" v-validate="'required'"> </textarea>
                                            <div class="invalid-feedback" v-if="errors.has('notes')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                label="Izberi, kako se dogodek financira"
                                                label-for="dateConfirmed"
                                                :class="{'is-invalid': errors.has('financesCoverage')}">

                                            <v-select
                                                    v-model="event.financesCoverage"
                                                    placeholder="financiranje dogodka"
                                                    id="financesCoverage"
                                                    name="financesCoverage"
                                                    v-validate="'required'"
                                                    :options="['plačajo udeleženci', 'plača društvo / ustanova / organizacija', 'občinska sredstva', 'dogodek je brezplačen', 'druga javna sredstva iz razpisov']"
                                            >
                                                <span slot="no-options">Ni zadetkov.</span>
                                            </v-select>
                                            <div class="invalid-feedback" v-if="errors.has('financesCoverage')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="otherFinancesCoverage"
                                                label="Pojasni financiranje dogodka (cena na udeležnca ipd.)"
                                                label-for="otherFinancesCoverage">

                                                <textarea v-model="event.otherFinancesCoverage"
                                                          id="otherFinancesCoverage"
                                                          placeholder="pojasni financiranje dogodka"
                                                          class="form-control" style="height: auto"
                                                          required rows="5"> </textarea>

                                        </b-form-group>

                                    </div>
                                </div>
                            </div>

                        </b-tab>
                        <b-tab title="3. Vsebinsko poročilo" :disabled="event.currentFormStep < 3">

                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">


                                        <b-form-group label="Ali je bil dogodek izveden?">
                                            <div>
                                                <b-form-checkbox
                                                        v-model="event.eventExecuted"
                                                        size="lg"
                                                        switch> Dogodek izveden
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="eventNotExecutedNotes"
                                                label="Napiši, zakaj dogodek ni bil izveden"
                                                label-for="otherFinancesCoverage"
                                                v-if="!event.eventExecuted"
                                        >
                                                <textarea v-model="event.eventNotExecutedNotes"
                                                          id="eventNotExecutedNotes"
                                                          placeholder="pojasni razloge, zakaj dogodek ni bil izveden"
                                                          class="form-control" style="height: auto"
                                                          required rows="5"> </textarea>
                                        </b-form-group>

                                        <div v-if="event.eventExecuted">
                                            <b-form-group
                                                    label="Določi dejanski čas začetka dogodka"
                                                    label-for="eventDurationStart">

                                                <VueCtkDateTimePicker id="eventDurationStart"
                                                                      format="YYYY-MM-DDTHH:mm:ssZ"
                                                                      class="withLabel" locale="sl"
                                                                      formatted="HH:mm"
                                                                      label="Čas začetka dogodka"
                                                                      :onlyTime="true"
                                                                      v-model="event.eventDurationStart"/>
                                            </b-form-group>

                                            <b-form-group
                                                    label="Določi dejanski čas zaključka dogodka"
                                                    label-for="date">

                                                <VueCtkDateTimePicker id="eventDurationEnd"
                                                                      format="YYYY-MM-DDTHH:mm:ssZ"
                                                                      class="withLabel" locale="sl"
                                                                      formatted="HH:mm"
                                                                      label="Čas zaključka dogodka"
                                                                      :onlyTime="true"
                                                                      v-model="event.eventDurationEnd"/>
                                            </b-form-group>

                                            <b-form-group
                                                    id="actualNumberOfParticipant"
                                                    label="Število udeležencev"
                                                    label-for="actualNumberOfParticipant">

                                                <b-input-group append="udeležencev">
                                                    <b-form-input id="actualNumberOfParticipant"
                                                                  v-model="event.actualNumberOfParticipant"
                                                                  placeholder="dejansko število udeležencev dogodka"
                                                                  type="number" trim></b-form-input>
                                                </b-input-group>
                                            </b-form-group>

                                            <b-form-group
                                                    id="participatingStaffMembers"
                                                    label="Sodelujoče osebje (zaposleni in prostovoljci)"
                                                    label-for="volunteers">

                                                <v-select
                                                        v-model="event.participatingStaffMembers"
                                                        id="participatingStaffMembers"
                                                        name="participatingStaffMembers"
                                                        multiple
                                                        label="last_name"
                                                        :options="users"
                                                        :reduce="item => item.id"
                                                >
                                                    <span slot="no-options">Ni zadetkov.</span>

                                                    <template slot="option" slot-scope="item">
                                                        {{ getOptionLabel(item) }}
                                                    </template>

                                                    <template slot="selected-option" slot-scope="item">
                                                        {{ getOptionLabel(item) }}
                                                    </template>


                                                </v-select>

                                            </b-form-group>

                                            <b-form-group
                                                    id="eventReport"
                                                    label="Poročilo v besedi"
                                                    label-for="eventReport"
                                            >
                                                <textarea v-model="event.eventReport" id="eventReport"
                                                          placeholder="napiši poročilo o dogodku" class="form-control"
                                                          style="height: auto"
                                                          required rows="10"> </textarea>
                                            </b-form-group>

                                            <b-form-group
                                                    id="eventPhotosLink"
                                                    label="Povezava do albuma fotografij v Google Drive"
                                                    label-for="eventPhotosLink"
                                            >

                                                <b-form-input id="eventPhotosLink" v-model="event.eventPhotosLink"
                                                              placeholder="vpiši URL naslov albuma dogodka" type="url"
                                                              trim></b-form-input>

                                            </b-form-group>

                                            <b-form-group
                                                    id="eventEvaluationMark"
                                                    label="Oceni zadovoljstvo z dogodkom (1 - najmanj, 5 - najbolj)"
                                                    label-for="eventEvaluationMark"
                                            >

                                                <b-form-group>
                                                    <b-form-radio-group
                                                            id="eventEvaluationMark"
                                                            v-model="event.eventEvaluationMark"
                                                            :options="[{ text: '1', value: 1 },{ text: '2', value: 2 },{ text: '3', value: 3 },{ text: '4', value: 4 },{ text: '5', value: 5 }]"
                                                            buttons
                                                            button-variant="outline-primary"
                                                            name="eventEvaluationMark"
                                                    ></b-form-radio-group>
                                                </b-form-group>

                                            </b-form-group>

                                            <b-form-group
                                                    id="postMortemNotes"
                                                    label="Opombe, komentarji, predlogi za izboljšave"
                                                    label-for="postMortemNotes"
                                            >
                                                <textarea v-model="event.postMortemNotes" id="postMortemNotes"
                                                          placeholder="napiši predloge, komentarje, predloge za izboljšave"
                                                          class="form-control" style="height: auto"
                                                          required rows="5"> </textarea>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </b-tab>
                        <b-tab title="4. Finančno poročilo" :disabled="event.currentFormStep < 3">

                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">

                                        <b-form-group
                                                label="Izberi, kako se dogodek financira"
                                                label-for="paymentMethod"
                                                :class="{'is-invalid': errors.has('paymentMethod')}">

                                            <v-select
                                                    v-model="event.paymentMethod"
                                                    placeholder="način plačila"
                                                    id="paymentMethod"
                                                    name="paymentMethod"
                                                    :options="['plačilo v gotovini', 'nakazilo na TRR']"
                                                    multiple>
                                                <span slot="no-options">Ni zadetkov.</span>
                                            </v-select>
                                            <div class="invalid-feedback" v-if="errors.has('paymentMethod')">
                                                Polje ne sme biti prazno.
                                            </div>
                                        </b-form-group>

                                        <div v-if="event.paymentMethod && event.paymentMethod.length > 0 && event.paymentMethod.indexOf('plačilo v gotovini') > -1">
                                            <b-form-group
                                                    id="totalAmountReceivedInCash"
                                                    label="Skupni znesek plačil v gotovini"
                                                    label-for="totalAmountReceivedInCash">

                                                <b-input-group append="eur">
                                                    <b-form-input id="totalAmountReceivedInCash"
                                                                  v-model="event.totalAmountReceivedInCash"
                                                                  placeholder="vnesi skupni znesek plačil v gotovini"
                                                                  step="0.01"
                                                                  type="number" trim></b-form-input>
                                                </b-input-group>
                                            </b-form-group>

                                            <b-form-group
                                                    label="Plačniki v gotovini"
                                                    label-for="payersInCash">

                                                <b-form-input id="payersInCash"
                                                              v-model="event.payersInCash"
                                                              placeholder="navedi plačnike, ki so plačali v gotovini"
                                                              type="text" trim></b-form-input>
                                            </b-form-group>

                                            <div class="vkr mt-4 mb-5">
                                                <h5>Vezana knjiga računov</h5>

                                                <div class="table-responsive">

                                                    <table class="table">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>št. izdanega računa</th>
                                                            <th>št. VKR</th>
                                                            <th>št. seta</th>
                                                            <th>vrednost računa</th>
                                                            <th style="width: 180px;">akcije</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-if="event.vkrData.length == 0">
                                                            <td colspan="6" class="text-center">
                                                                <em class="text-muted"><i
                                                                        class="fa fa-exclamation-triangle"></i> Ni
                                                                    vnosov v VKR</em>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="event.vkrData.length > 0"
                                                            v-for="(item,index) in event.vkrData">
                                                            <td>{{index+1}}</td>
                                                            <td>{{item.receiptNumber}}</td>
                                                            <td>{{item.vkrNumber}}</td>
                                                            <td>{{item.setNumber}}</td>
                                                            <td>{{parseFloat(item.amount).toFixed(2)}}</td>
                                                            <td>
                                                                <a class="bnt btn-sm btn-primary text-white"
                                                                   @click="editVkrItem(index)"><i
                                                                        class="fa fa-edit"></i> Uredi</a>
                                                                <a class="bnt btn-sm btn-danger text-white"
                                                                   @click="deleteVkrItem(index)"><i
                                                                        class="fa fa-trash"></i> Izbriši</a>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>

                                                    <a class="btn btn-success btn-sm text-white"
                                                       @click="editVkrItem(null)"><i class="fa fa-plus"></i> Dodaj vnos
                                                        v VKR</a>
                                                </div>
                                            </div>

                                        </div>

                                        <div v-if="event.paymentMethod && event.paymentMethod.length > 0 && event.paymentMethod.indexOf('nakazilo na TRR') > -1">
                                            <b-form-group
                                                    id="totalAmountReceivedInBankAccount"
                                                    label="Skupni znesek plačil na TRR"
                                                    label-for="totalAmountReceivedInBankAccount">

                                                <b-input-group append="eur">
                                                    <b-form-input id="totalAmountReceivedInBankAccount"
                                                                  v-model="event.totalAmountReceivedInBankAccount"
                                                                  placeholder="vnesi skupni znesek plačil na TRR"
                                                                  step="0.01"
                                                                  type="number" trim></b-form-input>
                                                </b-input-group>
                                            </b-form-group>

                                            <b-form-group
                                                    label="Plačniki preko nakazil na TRR"
                                                    label-for="payersThroughBank">

                                                <b-form-input id="payersThroughBank"
                                                              v-model="event.payersThroughBank"
                                                              placeholder="navedi plačnike, ki so plačali na TRR"
                                                              type="text" trim></b-form-input>
                                            </b-form-group>
                                        </div>


                                        <b-form-group
                                                id="paymentNotes"
                                                label="Druge opombe in pojasnila"
                                                label-for="paymentNotes"
                                        >
                                                <textarea v-model="event.paymentNotes" id="paymentNotes"
                                                          placeholder="druge opombe in pojasnila"
                                                          class="form-control" style="height: auto"
                                                          required rows="5"> </textarea>
                                        </b-form-group>

                                        <b-form-group label="Ali je bila prejeta donacija?">
                                            <div>
                                                <b-form-checkbox
                                                        v-model="event.isDonationReceived"
                                                        size="lg"
                                                        switch> Donacija je bila prejeta
                                                </b-form-checkbox>
                                            </div>
                                        </b-form-group>

                                        <b-form-group
                                                id="totalDonationReceived"
                                                label="Skupni prejeti znesek donacij"
                                                label-for="totalDonationReceived"
                                                v-if="event.isDonationReceived">

                                            <b-input-group append="eur">
                                                <b-form-input id="totalDonationReceived"
                                                              v-model="event.totalDonationReceived"
                                                              placeholder="vnesi skupni prejei znesek domacij na dogodku"
                                                              type="number" trim></b-form-input>
                                            </b-input-group>
                                        </b-form-group>

                                    </div>
                                </div>
                            </div>

                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteEventConfirmation()"><i
                            class="fa fa-trash"></i>
                        Izbriši
                        dogodek
                    </button>

                    <button v-if="!editMode" type="submit" @click="addEvent()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke o dogodku
                    </button>


                    <button v-if="editMode" type="submit" @click="updateEvent()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Posodobi podatke o dogodku
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'Events'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>


        <b-modal ref="vkr-modal" title="VKR podatki" size="lg">


            <div class="row">
                <div class="col-md-12 mb-0">

                    <b-form-group
                            label="Številka računa"
                            label-for="receiptNumber">

                        <b-form-input id="receiptNumber"
                                      v-model="vkr.receiptNumber"
                                      placeholder="vnesi številko računa"
                                      type="text" trim></b-form-input>

                    </b-form-group>

                    <b-form-group
                            label="VKR številka"
                            label-for="vkrNumber">

                        <b-form-input id="vkrNumber"
                                      v-model="vkr.vkrNumber"
                                      placeholder="vnesi VKR številko"
                                      type="text" trim></b-form-input>

                    </b-form-group>

                    <b-form-group
                            label="Številka seta"
                            label-for="setNumber">

                        <b-form-input id="setNumber"
                                      v-model="vkr.setNumber"
                                      placeholder="vnesi številko seta"
                                      type="text" trim></b-form-input>

                    </b-form-group>

                    <div class="vkrServicesAndGoods">
                        <h5>Storitev / blago</h5>

                        <div class="table-responsive">

                            <table class="table">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>storitev / blago</th>
                                    <th>cena na enoto</th>
                                    <th>količina</th>
                                    <th>cena</th>
                                    <th style="width: 180px;">akcije</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="!vkr.servicesAndGoods || (vkr.servicesAndGoods && vkr.servicesAndGoods.length == 0)">
                                    <td colspan="6" class="text-center">
                                        <em class="text-muted"><i class="fa fa-exclamation-triangle"></i> Ni vnosov v
                                            VKR</em>
                                    </td>
                                </tr>
                                <tr v-if="vkr.servicesAndGoods && vkr.servicesAndGoods.length > 0"
                                    v-for="(item,index) in vkr.servicesAndGoods">
                                    <td>{{index+1}}</td>
                                    <td>{{item.serviceOrGood}}</td>
                                    <td>{{item.pricePerItem}}</td>
                                    <td>{{item.numberOfItems}}</td>
                                    <td>{{parseFloat(item.price).toFixed(2)}}</td>
                                    <td>
                                        <a class="bnt btn-sm btn-primary text-white"
                                           @click="editVkrServicesAndGoodsItems(index)"><i
                                                class="fa fa-edit"></i> Uredi</a>
                                        <a class="bnt btn-sm btn-danger text-white"
                                           @click="deleteVkrServicesAndGoodsItems(index)"><i
                                                class="fa fa-trash"></i> Izbriši</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <a class="btn btn-success btn-sm text-white"
                               @click="editVkrServicesAndGoodsItems(null)"><i class="fa fa-plus"></i> Dodaj vnos v
                                seznam</a>
                        </div>

                    </div>

                    <b-form-group
                            label="Vrednost računa"
                            label-for="amount">

                        <b-input-group append="eur">
                            <b-form-input id="amount"
                                          v-model="vkr.amount"
                                          placeholder="vnesi vrednost računa"
                                          step="0.01"
                                          type="number" trim disabled></b-form-input>
                        </b-input-group>
                    </b-form-group>

                </div>
            </div>


            <div slot="modal-footer" class="w-100">
                <b-button
                        variant="primary"
                        class="float-right"
                        @click="updateVkrData()">
                    Potrdi
                </b-button>
            </div>

        </b-modal>


        <b-modal ref="vkr-servicesAndGoodsModal" title="Blago / storitev" size="lg">

            <div v-if="servicesAndGoodsIndex !== null">

                <div class="row">
                    <div class="col-md-12 mb-0">


                        <b-form-group
                                label="Blago / storitev"
                                label-for="serviceOrGood">

                            <b-form-input id="serviceOrGood"
                                          v-model="vkr.servicesAndGoods[servicesAndGoodsIndex].serviceOrGood"
                                          placeholder="navedi blago / storitev"
                                          @input="$forceUpdate()"
                                          type="text" trim></b-form-input>

                        </b-form-group>

                        <b-form-group
                                label="Cena na enoto"
                                label-for="pricePerItem">

                            <b-form-input id="pricePerItem"
                                          v-model="vkr.servicesAndGoods[servicesAndGoodsIndex].pricePerItem"
                                          placeholder="vnesi ceno na enoto"
                                          step="0.01"
                                          @input="(e) => {$forceUpdate(); vkr.servicesAndGoods[servicesAndGoodsIndex].price = vkr.servicesAndGoods[servicesAndGoodsIndex].pricePerItem * vkr.servicesAndGoods[servicesAndGoodsIndex].numberOfItems; }"
                                          type="number" trim></b-form-input>

                        </b-form-group>

                        <b-form-group
                                label="Količina / ševilo enot"
                                label-for="numberOfItems">

                            <b-form-input id="numberOfItems"
                                          v-model="vkr.servicesAndGoods[servicesAndGoodsIndex].numberOfItems"
                                          placeholder="vnesi količino / število enot"
                                          step="0.01"
                                          @input="(e) => {$forceUpdate(); vkr.servicesAndGoods[servicesAndGoodsIndex].price = vkr.servicesAndGoods[servicesAndGoodsIndex].pricePerItem * vkr.servicesAndGoods[servicesAndGoodsIndex].numberOfItems; }"
                                          type="number" trim></b-form-input>

                        </b-form-group>

                        <b-form-group
                                label="Cena"
                                label-for="price">

                            <b-input-group append="eur">
                                <b-form-input id="price"
                                              v-model="vkr.servicesAndGoods[servicesAndGoodsIndex].price"
                                              step="0.01"
                                              type="number" trim disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>

                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        variant="primary"
                        class="float-right"
                        @click="updateVkrServicesAndGoodsData()">
                    Potrdi
                </b-button>
            </div>


        </b-modal>

    </div>
</template>


<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    name: 'EditEvent',
    components: {
      vSelect,
      Multiselect
    },
    data () {
      return {
        event: {
          id: '',
          project: [],
          updatedAt: null,
          updatedBy: '',
          createdAt: null,
          createdBy: '',
          currentFormStep: null,

          // step 1
          activities: '',
          addressName: '',
          address: '',
          municipality: '',
          date: null,
          multipleDayEvent: false,
          endDate: null,
          formattedDate: null,
          dateConfirmed: '',

          // step 2
          eventName: '',
          coHosts: '',
          description: '',
          registrationRequired: false,
          registrationLink: '',
          maxParticipantsLimit: false,
          maxParticipants: null,
          advertising: false,
          notes: '',
          financesCoverage: '',
          otherFinancesCoverage: '',

          // step 3
          eventExecuted: false,
          eventNotExecutedNotes: '',
          eventDurationStart: null,
          eventDurationEnd: null,
          actualNumberOfParticipant: null,
          participatingStaffMembers: [],
          eventReport: '',
          eventPhotosLink: '',
          eventEvaluationMark: null,
          postMortemNotes: '',

          // step 4
          paymentMethod: [],
          totalAmountReceivedInCash: null,
          payersInCash: '',
          totalAmountReceivedInBankAccount: null,
          payersThroughBank: '',
          paymentNotes: '',
          vkrData: [],
          isDonationReceived: false,
          totalDonationReceived: null
        },
        roles: this.$store.getters.getRoles,
        projects: this.$store.getters.getProjects,
        id: this.$route.params.id,
        users: this.$store.getters.getUsers,
        editMode: false,
        vkr: {
          servicesAndGoods: []
        },
        vkrIndex: null,
        servicesAndGoodsIndex: null
      }
    },
    computed: {
      validationRuleMultipleDayEvent () {
        console.log("multipleDayEvent", this.event.multipleDayEvent);
        return this.event.multipleDayEvent ? 'required' : ''
      },
      validationRuleRegistrationRequired () {
        return this.event.registrationRequired ? 'required' : ''
      },
      validationRuleMaxParticipants () {
        return this.event.maxParticipantsLimit ? 'required' : ''
      }
    },
    mounted () {
      const _this = this

      if (_this.id) {
        _this.editMode = true
        _this.loadEvent()
      } else {
        _this.editMode = false
      }

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (_this.$store.getters.getRoles.length === 0) {
        _this.$store.dispatch('retrieveRoles').then(() => {
          _this.roles = _this.$store.getters.getRoles
        })
      }

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

      // _this.$refs.autocomplete.$on('place_changed', (res) => {
      //   console.log(res)
      //
      //   // _this.address.route = _this.getGeocompleteData(res, 'route');
      //   // _this.address.street_number = _this.getGeocompleteData(res, 'street_number');
      //   // _this.address.postal_code = _this.getGeocompleteData(res, 'postal_code');
      //   // _this.address.postal_town = _this.getGeocompleteData(res, 'postal_town');
      //   _this.event.municipality = _this.getGeocompleteData(res, 'administrative_area_level_1')
      //   // _this.address.country = _this.getGeocompleteData(res, 'country');
      //
      //   _this.event.address = res.formatted_address
      //
      //   console.log(_this.$refs.autocomplete)
      // });

      // _this.loadRoles()
      // _this.loadProjects()

    },
    methods: {

      onPlaceChanged (res) {
        const _this = this

        console.log(res)
        _this.event.municipality = _this.getGeocompleteData(res, 'administrative_area_level_1')
        _this.event.address = res.formatted_address
      },
      getOptionLabel (option) {
        console.log(option)
        return this.getReadableUser(option.id)
      },

      loadEvent () {
        const _this = this

        db.collection('events')
          .doc(this.id)
          .get()
          .then(snapshot => {
            const document = snapshot.data()

            _.forOwn(document, function (value, key) {
              if (key === 'date' || key === 'endDate' || key === 'eventDurationStart' || key === 'eventDurationEnd') {
                document[key] = value ? _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ') : null
              } else if (key === 'address') {
                _this.$refs.autocomplete.$refs.input.value = value // manually set init GmapAutocomplete value
                console.log(_this.$refs.autocomplete)
              } else if (key === 'participatingStaffMembers') {
                //document[key] = ["41YfNZnoHZ2SV89Cfmv2","3qxMdEm5WiCcHAlO0ZSB","CFzNWl3mrU8UBxvjUZjJ"]
                //console.log(key, value, '<--- tole');
                //document[key] = [];
              }
            })

            _this.event = document

            // set enabled form tabs
            if (_this.event.currentFormStep === 1 && _this.event.dateConfirmed === 'termin je potrjen') {
              _this.event.currentFormStep = 2
            }

            // if event with confirmed date is in the past, enable all tabs
            if (_this.event.currentFormStep === 2 && _this.event.dateConfirmed === 'termin je potrjen' && _this.moment(_this.event.date).diff(_this.moment(new Date())) < 0) {
              _this.event.currentFormStep = 3
            }

          })

      },

      checkDateConfirmedValue () {
        const _this = this

        console.log('_this.event.dateConfirmed', _this.event.dateConfirmed)
        if (_this.event.dateConfirmed === 'termin je potrjen') {
          _this.event.currentFormStep = 2
        } else {
          _this.event.currentFormStep = 1
        }

      },

      async updateEvent () {
        const _this = this
        const currentEvent = db.collection('events').doc(this.id)

        await _this.validateFields()

        if (_this.errors.items.length > 0) {
          await _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
          return false
        }

        return currentEvent.update({
          // step1
          activities: _this.event.activities,
          address: _this.event.address,
          addressName: _this.event.addressName,
          municipality: _this.event.municipality,
          updatedAt: new Date(),
          updatedBy: JSON.parse(sessionStorage.getItem('DP_user')).id,
          createdAt: _this.event.createdAt,
          createdBy: _this.event.createdBy,
          date: _this.moment(_this.event.date, 'YYYY-MM-DDTHH:mm:ssZ').toDate(),
          multipleDayEvent: _this.event.multipleDayEvent,
          endDate: _this.event.multipleDayEvent ? _this.moment(_this.event.endDate, 'YYYY-MM-DDTHH:mm:ssZ').toDate() : null,
          dateConfirmed: _this.event.dateConfirmed,
          project: _this.event.project,
          currentFormStep: _this.event.currentFormStep,

          // step2
          eventName: _this.event.eventName,
          coHosts: _this.event.coHosts,
          description: _this.event.description,
          registrationRequired: _this.event.registrationRequired,
          registrationLink: _this.event.registrationLink,
          maxParticipantsLimit: _this.event.maxParticipantsLimit,
          maxParticipants: _this.event.maxParticipants,
          advertising: _this.event.advertising,
          notes: _this.event.notes,
          financesCoverage: _this.event.financesCoverage,
          otherFinancesCoverage: _this.event.otherFinancesCoverage,

          // step3
          eventExecuted: _this.event.eventExecuted,
          eventNotExecutedNotes: _this.event.eventNotExecutedNotes,
          eventDurationStart: _this.event.eventDurationStart ? new Date(_this.event.eventDurationStart) : null,
          eventDurationEnd: _this.event.eventDurationEnd ? new Date(_this.event.eventDurationEnd) : null,
          actualNumberOfParticipant: _this.event.actualNumberOfParticipant,
          participatingStaffMembers: _this.event.participatingStaffMembers,
          eventReport: _this.event.eventReport,
          eventPhotosLink: _this.event.eventPhotosLink,
          eventEvaluationMark: _this.event.eventEvaluationMark,
          postMortemNotes: _this.event.postMortemNotes,

          // step4
          paymentMethod: _this.event.paymentMethod,
          totalAmountReceivedInCash: _this.event.totalAmountReceivedInCash,
          payersInCash: _this.event.payersInCash,
          vkrData: _this.event.vkrData,
          totalAmountReceivedInBankAccount: _this.event.totalAmountReceivedInBankAccount,
          payersThroughBank: _this.event.payersThroughBank,
          paymentNotes: _this.event.paymentNotes,
          isDonationReceived: _this.event.isDonationReceived,
          totalDonationReceived: _this.event.totalDonationReceived
        })
          .then(function () {
            // _this.$store.dispatch('retrieveEvents', true).then(() => {
            _this.$router.push({name: 'Events'})
            // })

          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating event: ', error)
          })

      },

      async addEvent () {
        const _this = this

        await _this.validateFields()

        if (_this.errors.items.length > 0) {
          await _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
          return
        }

        let ref = db.collection('events').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              _this.id = doc.data().id
              _this.event.createdAt = new Date()
              _this.event.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id
              _this.updateEvent()
            })
          })

      },

      async validateFields () {
        let _this = this

        // _this.$validator.validate('project', _this.event.project).then(result => {
        //   console.log(result);
        // });

        if (_this.event.currentFormStep === null || _this.event.currentFormStep === 1) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

        } else if (_this.event.currentFormStep === 2) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

          await _this.$validator.validate('eventName', _this.event.eventName)
          await _this.$validator.validate('description', _this.event.description)
          _this.event.registrationRequired ? await _this.$validator.validate('registrationLink', _this.event.registrationLink) : null
          _this.event.maxParticipantsLimit ? await _this.$validator.validate('maxParticipants', _this.event.maxParticipants) : null
          await _this.$validator.validate('notes', _this.event.notes)
          await _this.$validator.validate('financesCoverage', _this.event.financesCoverage)

        } else if (_this.event.currentFormStep === 3) {
          await _this.$validator.validate('project', _this.event.project)
          await _this.$validator.validate('dateConfirmed', _this.event.dateConfirmed)
          await _this.$validator.validate('date', _this.event.date)
          _this.event.multipleDayEvent ? await _this.$validator.validate('endDate', _this.event.endDate) : null
          await _this.$validator.validate('addressName', _this.event.addressName)
          await _this.$validator.validate('address', _this.event.address)
          await _this.$validator.validate('municipality', _this.event.municipality)
          await _this.$validator.validate('activities', _this.event.activities)

          await _this.$validator.validate('eventName', _this.event.eventName)
          await _this.$validator.validate('description', _this.event.description)
          _this.event.registrationRequired ? await _this.$validator.validate('registrationLink', _this.event.registrationLink) : null
          _this.event.maxParticipantsLimit ? await _this.$validator.validate('maxParticipants', _this.event.maxParticipants) : null
          await _this.$validator.validate('notes', _this.event.notes)
          await _this.$validator.validate('financesCoverage', _this.event.financesCoverage)

        }

        // if(_this.errors.items.length > 0) {
        //   return false
        // } else {
        //   return true
        // }

      },
      deleteEventConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati dogodek, vnešen za dan  ' + _this.moment(_this.event.date).format('DD. MM. YYYY, HH:mm') + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteEvent()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteEvent () {
        const _this = this

        db.collection('events').doc(_this.id).delete()
          .then(function () {
            _this.$router.push({name: 'Events'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting event: ', error)
          })
      },

      getGeocompleteData (result, searchItem) {
        let geocompleteData = ''

        if (typeof (_.find(result.address_components, function (ac) {
          return ac.types[0] == searchItem
        })) != 'undefined') {
          geocompleteData = (_.find(result.address_components, function (ac) {
            return ac.types[0] == searchItem
          }).long_name)
        }
        console.log(geocompleteData)
        return geocompleteData
      },

      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },

      editVkrItem (index) {
        const _this = this

        if (index === null) {
          _this.vkr = {
            index: null,
            receiptNumber: '',
            vkrNumber: '',
            setNumber: '',
            amount: null,
            servicesAndGoods: []
          }
          _this.vkrIndex = 0

        } else {
          _this.vkr = {
            index: index,
            receiptNumber: _this.event.vkrData[index].receiptNumber,
            vkrNumber: _this.event.vkrData[index].vkrNumber,
            setNumber: _this.event.vkrData[index].setNumber,
            amount: parseFloat(_this.event.vkrData[index].amount).toFixed(2),
            servicesAndGoods: _this.event.vkrData[index].servicesAndGoods,
          }
          _this.vkrIndex = index
        }
        _this.calculateSum();
        _this.showVkrModal()

      },

      deleteVkrItem (index) {
        const _this = this

        _this.event.vkrData.splice(index, 1)
      },

      updateVkrData () {
        const _this = this

        console.log("updateVkrData");

        if (_this.vkr.index === null) {
          delete _this.vkr.index
          _this.event.vkrData.push(_this.vkr)
        } else {
          _this.event.vkrData[_this.vkr.index] = _this.vkr
          delete _this.event.vkrData[_this.vkr.index].index
        }

        _this.servicesAndGoodsIndex = null;
        _this.closeModal()
      },

      showVkrModal () {
        this.$refs['vkr-modal'].show()
      },

      closeModal () {
        const _this = this

        if (_this.$refs['vkr-modal']) {
          _this.$refs['vkr-modal'].hide()
          _this.vkr = {}
        }
      },

      showVkrServicesAndGoodsModal () {
        this.$refs['vkr-servicesAndGoodsModal'].show()
      },

      closeVkrServicesAndGoodsModal () {
        const _this = this

        if (_this.$refs['vkr-servicesAndGoodsModal']) {
          _this.$refs['vkr-servicesAndGoodsModal'].hide()
          // _this.servicesAndGoodsIndex = null;
        }
      },

      editVkrServicesAndGoodsItems (index) {
        const _this = this

        console.log('index', index)
        console.log('_this.vkrIndex', _this.vkrIndex)

        console.log('_this.vkr', _this.vkr)
        console.log('_this.event', _this.event)
        console.log('vkrData', _this.event.vkrData)
        console.log('vkrData @ index', _this.event.vkrData[_this.vkrIndex])

        if (index === null) {
          _this.vkr.servicesAndGoods.push({
            index: _this.vkr.servicesAndGoods.length + 1,
            serviceOrGood: '',
            pricePerItem: 0,
            numberOfItems: 0,
            price: 0
          })
          _this.servicesAndGoodsIndex = _this.vkr.servicesAndGoods.length-1;

        } else {
          _this.servicesAndGoodsIndex = index
          _this.vkr.servicesAndGoods[index] = {
            index: index,
            serviceOrGood: _this.vkr.servicesAndGoods[index].serviceOrGood,
            pricePerItem: _this.vkr.servicesAndGoods[index].pricePerItem,
            numberOfItems: _this.vkr.servicesAndGoods[index].numberOfItems,
            price: parseFloat(_this.vkr.servicesAndGoods[index].price).toFixed(2),
          }
        }
        _this.showVkrServicesAndGoodsModal()
      },

      deleteVkrServicesAndGoodsItems(index) {
        const _this = this

        _this.vkr.servicesAndGoods.splice(index, 1)
      },

      updateVkrServicesAndGoodsData () {
        const _this = this

        console.log('--->', _this.vkr.servicesAndGoods[_this.servicesAndGoodsIndex])

        _this.calculateSum();
        _this.$forceUpdate();
        _this.closeVkrServicesAndGoodsModal()
      },

      calculateSum() {
        const _this = this;

        let total = 0;
        _.map(_this.vkr.servicesAndGoods, function (val) {
            total += val.price
        });

        _this.vkr.amount = total;
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/EditEvent.vue